export function canAccessSystemSettings(user) {
  return user && (user.super_admin == 1 || user.president == 1);
}

export function guardSystemSettingsRoute(to, from, next, store) {
  const user = store.getters["USERACCOUNT_LOAD"];

  if (canAccessSystemSettings(user)) {
    next();
    return;
  }

  next("/no-access");
}
